<template>

    <div v-if="item.TblComboGrpId43 == 1802 || item.TblComboGrpId43 == 1803" class="reply "
        :class="[replyForCustomer ? ['reply-customer'] : ['']]" @click="goToRepMess()">
        <span v-if="item.ReplyMessageComboGrp43 == 1804">تصویر- </span>
        <span v-if="item.ReplyMessageComboGrp43 == 1805">فایل- </span>
        {{ item.ReplyMessage.slice(0, 45) }}
    </div>

    <div v-else-if="item.TblComboGrpId43 == 1804 && replyForCustomer" class="col-12 d-flex justify-content-start"
        @click="goToRepMess()">
        <div class="reply-img col-8 col-xl-4 justify-content-end d-flex reply-customer">
            <span class="font-color" v-if="item.ReplyMessageComboGrp43 == 1804">تصویر- </span>
            <span class="font-color" v-if="item.ReplyMessageComboGrp43 == 1805">فایل- </span>
            {{ item.ReplyMessage.slice(0, 45) }}
        </div>
    </div>

    <div v-else-if="(item.TblComboGrpId43 == 1804 || item.TblComboGrpId43 == 2500) && !replyForCustomer"
        class="col-12 d-flex justify-content-end" @click="goToRepMess()">
        <div class="reply-img col-8 col-xl-4 justify-content-end d-flex">
            <span class="font-color" v-if="item.ReplyMessageComboGrp43 == 1804">تصویر- </span>
            <span class="font-color" v-if="item.ReplyMessageComboGrp43 == 1805">فایل- </span>
            {{ item.ReplyMessage.slice(0, 45) }}
        </div>
    </div>

    <div v-else-if="(item.TblComboGrpId43 == 1805 || item.TblComboGrpId43 == 2501)" class="reply"
        :class="[replyForCustomer ? ['reply-customer'] : ['']]" @click="goToRepMess()">
        <span class="font-color" v-if="item.ReplyMessageComboGrp43 == 1804">تصویر- </span>
        <span class="font-color" v-if="item.ReplyMessageComboGrp43 == 1805">فایل- </span>
        {{ item.ReplyMessage.slice(0, 45) }}
    </div>


</template>


<script>

export default {
    props: ['item', 'replyForCustomer', 'chatMessage'],
    created() {
        if (this.item.ReplyMessage != null) {
            this.item.ReplyMessage = this.item.ReplyMessage.replaceAll("\n", " ")
        }
        if (this.item.ReplyMessageId != null) {
            let findRep = this.chatMessage.find(x => x.Id == this.item.ReplyMessageId)
            if (findRep != undefined) {
                this.item.ReplyMessage = findRep.Message.replaceAll("\n", " ")
                this.item.ReplyMessageComboGrp43 = findRep.TblComboGrpId43
            }
        }
    },

    methods: {
        goToRepMess() {
            let mess = document.getElementById(this.item.ReplyMessageId + 'mainMess')
            mess.scrollIntoView()
            mess.classList.add('bg-secondary')
            setTimeout(() => {
                mess.classList.remove('bg-secondary')
            }, 300);
        }
    }
}

</script>


<style scoped>
.reply {
    border: 2px solid 06d755;
    background-color: #bef498;
    font-size: 10px;
    margin: -12px -12px 5px -12px;
    padding: 4px;
    font-style: italic;
    cursor: pointer;
    color: #153147;
    height: 45px;
}

.reply-img {
    border: 2px solid 06d755;
    background-color: #bef498;
    border-radius: 5px;
    font-size: 10px;
    padding: 4px;
    font-style: italic;
    cursor: pointer;
    color: #153147;
    height: 30px;

}

.reply-customer {
    background-color: rgb(230, 230, 230);
}

.reply span {
    color: #153147 !important;
}

.font-color {
    color: #153147 !important;
}
</style>